module.exports = __webpack_public_path__ + "img/g_bg2.29bc71c5.jpg";